export var ACCOUNT = [6459, 53315];
export var DOMAIN = "m";
export var PAGES = ['product', 'home', 'search', 'subcategory'];